import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Mission from '../components/Mission'
import Experience from '../components/Experience'
import Carousel from '../components/Carousel'
import Footer from '../components/Footer'


const Home = () => {
  return (
    <div>
        <Navbar/>
        <Hero />
        <Mission />
        <Experience />
        <Carousel />
        <Footer />






    </div>
  )
}

export default Home